export const ClientActivityType = {
  AppOpen: "AppOpen",
  PageView: "PageView",
  PushOpen: "PushOpen",
  SignIn: "SignIn",
  ProductView: "ProductView",
  CartAdd: "CartAdd",
  CartRemove: "CartRemove",
  CardView: "CardView",
  CardTap: "CardTap",
} as const;

export type ClientActivityType = (typeof ClientActivityType)[keyof typeof ClientActivityType];

/**
 * The kinds of Discover card and offer the patient app reports views and taps for. `Promotion` is
 * every card showing one promotion on its own (a Discover offer card or carousel tile, a Home or
 * Shop special-offer card), keyed by the promotion id; `CampaignCard` is a Discover layout widget,
 * keyed by the widget id.
 */
export const CardKind = {
  CampaignCard: "CampaignCard",
  Promotion: "Promotion",
} as const;

export type CardKind = (typeof CardKind)[keyof typeof CardKind];

/** What a tap on a card opened: its main button, its details, a redeem action or an external link. */
export const CardTapTarget = {
  Cta: "cta",
  Details: "details",
  Redeem: "redeem",
  Link: "link",
} as const;

export type CardTapTarget = (typeof CardTapTarget)[keyof typeof CardTapTarget];

/** Which card, by its real entity id, and the title the patient saw on it. */
export interface CardActivity {
  cardKind: CardKind;
  cardId: string;
  name: string;
}

/** The card identity without its title, for a component that already holds the title as a prop. */
export type CardIdentity = Pick<CardActivity, "cardKind" | "cardId">;

export interface CardTapActivity extends CardActivity {
  target: CardTapTarget;
}

export interface ClientActivityEntry {
  id: string;
  type: ClientActivityType;
  occurredAtUtc: string;
  beforeSignIn: boolean;
  route?: string;
  properties?: Record<string, string>;
}

export interface ClientActivityDetails {
  route?: string;
  properties?: Record<string, string>;
}

export interface ClientActivitySendOptions {
  keepalive: boolean;
}

export type ClientActivitySend = (
  entries: ClientActivityEntry[],
  options: ClientActivitySendOptions,
) => Promise<void>;

export interface ClientActivityStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}
